export const getCurrencyName = (currencyOrUnit) => {
  if (!currencyOrUnit) return "MMK";
  if (typeof currencyOrUnit === "string") return currencyOrUnit || "MMK";

  const currency =
    currencyOrUnit.currency ??
    currencyOrUnit.currency_name ??
    currencyOrUnit;

  if (!currency) return "MMK";
  if (typeof currency === "string") return currency || "MMK";

  return currency.name || currencyOrUnit.currency_name || "MMK";
};

export const formatPrice = (amount, currencyOrUnit) => {
  const value = Number(amount);
  const displayValue = Number.isFinite(value) ? value.toLocaleString() : "0";
  return `${displayValue} ${getCurrencyName(currencyOrUnit)}`;
};
